<template>
    <div>
        <MasterLayout>
            <div class="fuel_consumption_row" ref="tableREF">
                <div
                    class="fuel_consumption_row_right_section mr-3 vr__bg"
                    style="border-radius: 12px; flex: 0 0 97%; height: 200px"
                    :style="[
                        {
                        backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover'
                        }
                    ]"
                    >
                    <div class="row align-items-center justify-content-center" style="height: 100%">
                        <div class="col-md-12" style="display: flex;justify-content: center;">
                            <h4 class="text-center text-white">{{$t('text.createVehicle.title')}} <i class="fa fa-car ml-3" style="color: white" aria-hidden="true"></i></h4>
                        </div>
                    </div>
                    
                </div>
    
            </div>
             <section class="section_2 mt-10 mt-3" style="width: 50%;padding: 32px; height: auto">
               <div class="row  py-3" style="box-shadow: none">
                   <div class="" style="box-shadow: none; width: 100%; margin: 0 auto">
                       <div class="" style="box-shadow: none">
                           <h6 class="add_driver_header text-center py-3">{{$t('text.createVehicle.enterVehicleDetails')}}</h6>
                           <div class="text-center driver_btns_div">
                               <!-- <button class="mr-3 upload_btn">Uploader Bulk Vehicle <span></span> </button>
                               <button class="download_btn">Download sample <span></span> </button> -->
                           </div>
                           <div class="Add_driver_form " style="width: 80%; margin: 0 auto">
                                <div class="form_input_section">
                                     <div class="input__block " ref="plate_input_div">
                                        <input
                                            type="text"
                                            :placeholder="$t('text.createVehicle.plateNumberPlaceholder')"
                                            class="form-control input_full_width "
                                            @blur="captureFormEvents($event)"
                                            v-model="plateNumber"
                                        />
                                    </div>
                                    <div ref="plate_error_template"></div>
                                </div>
                                <!-- <div class="form_input_section mt-3">
                                     <div class="input__block " ref="name_input_div">
                                        <input
                                            type="text"
                                            :placeholder="$t('text.createVehicle.fullName')"
                                            class="form-control input_full_width "
                                            @blur="captureFormEvents($event)"
                                            v-model="name"
                                        />
                                    </div>
                                    <div ref="name_error_template"></div>
                                </div> -->
                                <!-- <div class="form_input_section mt-3">
                                    <div class="input__block " ref="phone_input_div">
                                        <input
                                            type="text"
                                            :placeholder="$t('text.createVehicle.phoneNumber')"
                                            class="form-control input_full_width "
                                            @blur="captureFormEvents($event)"
                                            v-model="phone"
                                        />
                                    </div>
                                    <div ref="phone_error_template"></div>
                                </div> -->
                                <div class="form_input_section mt-3">
                                    <div class="input__block " ref="balance_to_input_div">
                                        <select v-model="vehicleType">
                                            <option :value="$t('text.createVehicle.selectVehicleType')">{{$t('text.createVehicle.selectVehicleType')}}</option>
                                            <option value="Car/Lorry">{{$t('text.createVehicle.carOrLorry')}}</option>
                                            <option value="Motorcycle">{{$t('text.createVehicle.motorcycle')}}</option>
                                        </select>
                                    </div>
                                    <div ref="email_error_message"></div>
                                </div>
                                <div class="form_input_section mt-3">
                                     <div class="input__block " ref="balance_to_input_div">
                                         <select v-model="carMakeId" @change="getCarModel" >
                                            <option :value="$t('text.createVehicle.selectVehicleMake')">{{$t('text.createVehicle.selectVehicleMake')}}</option>
                                            <option v-for="(carMake , index)  in carMakes" :key="index" :value="carMake.id">{{carMake.make}}</option>
                                        </select>
                                    </div>
                                    <div ref="code_error_message"></div>
                                </div>
                                 <div class="form_input_section mt-3">
                                    <div class="input__block " ref="balance_to_input_div">
                                        <select v-model="carModelId" @change="getCarModel" >
                                            <option :value="$t('text.createVehicle.selectVehicleModel')">{{$t('text.createVehicle.selectVehicleModel')}}</option>
                                            <option v-for="(carModel , index)  in carModels" :key="index" :value="carModel.id">{{carModel.model}}</option>
                                        </select>
                                    </div>
                                    
                                    <div ref="address_error_message"></div>
                                </div>
                                <div class="form_input_section mt-3">
                                     <div class="input__block" ref="state_input_div">
                                        <input
                                            type="number"
                                            :placeholder="$t('text.createVehicle.modelYear')"
                                            class="form-control input_full_width "
                                            @blur="captureFormEvents($event)"
                                            v-model="modelYear"
                                        />
                                    </div>
                                    <div ref="state_error_message"></div>
                                </div>
                                <div class="text-center mt-4">
                                     <button class="save__btn record_expense_btn other_btn_4"  @click="createVehicle($event)"
                                            :disabled="isButtonDisabled ? true : null"
                                            style="border: 0;"
                                            :style= "[isButtonDisabled ? {cursor: 'not-allowed'} : {cursor: 'pointer'}]">{{$t('text.createVehicle.title')}}  <span></span> </button>
                                    <img src="@/assets/img/git_loader.gif" style="display:none" width="35px" class="ml-3 loader" />
                                </div>
                           </div>
                       </div>
                   </div>
               </div>
            </section>
            
        </MasterLayout>
    </div>
</template>

<script>

    import MasterLayout from "@/views/Customer/MasterLayout.vue";
    import backgroundUrl from '@/assets/img/danskebank.jpg'; 
    import cardBackgroundUrl from '@/assets/img/Group393.svg'; 
    import configObject from "@/config";

    import JQuery from 'jquery';
    let $ = JQuery;
    

    export  default {
        title: "Create Vehicle:: Epump Portal",
        name: "DashboardHome",
        components: {
            MasterLayout,
        },
        data() {
            return {
                backgroundUrl,
                cardBackgroundUrl,
                vehicles: null,
                showLoader: false,
                vehiclesCount: 0,
                name: null,
                phone: null,
                plateNumber: null,
                vehicleType: this.$t('text.createVehicle.selectVehicleType'),
                modelYear: null,
                isButtonDisabled: false,
                mode: "select mode",
                toggleReturnBalanceToDropDown: false,
                toggleValidityDropdown: false,
                carMakes: null,
                carModels: null,
                carMake:null,
                carMakeId: this.$t('text.createVehicle.selectVehicleMake'),
                carModelId: this.$t('text.createVehicle.selectVehicleModel'),
            }
        },
        created() {
            this.getCarMakes();
        },
        methods: {
            changeRoute ($newRoute) {
                this.$router.push({name: $newRoute});
            },
            showFundWalletModal () {
                this.$modal.show('fund-wallet');
            },
             validEmail(email) {
                var re =  /^[a-z][a-zA-Z0-9_.]*(\.[a-zA-Z][a-zA-Z0-9_.]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
                return re.test(email);
            },
            getValidityItem(name, value) {
                this.validity = name;
                this.validityValue = value
                this.toggleValidityDropdown = !this.toggleValidityDropdown;
                $(".validity_input").css("color", "white");
                $(".validity_input").val(name);
            },
            toggleReturnBalanceToDropDownDisplay() {
                this.toggleValidityDropdown = false;
                this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown;
            },
            toggleValidityDropDownDisplay() {
                    this.toggleValidityDropdown = !this.toggleValidityDropdown;
                    this.toggleReturnBalanceToDropDown = false;
            },
            getReturnBalanaceToDropdownItem(returnBalanceToDropdownItem) {
                this.returnBalanceTo = returnBalanceToDropdownItem;
                this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown;
                $(".balance_to_input").css('color' , 'white');
                $(".balance_to_input").val(returnBalanceToDropdownItem);
            },
            createSendVoucherArray($event,driverInfo){
                if(!$event.target.checked) {
                    let newDriversArray = this.driversArray.filter(driver => driver.id !== driverInfo.id);
                    this.driversArray = newDriversArray;
                }else {
                    this.driversArray.push({
                        id: driverInfo.id,
                        name: driverInfo.name,
                        phone: driverInfo.phone
                    })
                }
            },
            captureFormEvents($event) {
                 if($event.target.placeholder === this.$t('text.createVehicle.plateNumberPlaceholder')){
                    if($event.target.value === ""){
                        this.$refs.plate_error_template.style.display = "block";
                        // this.$refs.plate_error_template.innerHTML = "Plate Number field cannot be blank";
                        this.$refs.plate_input_div.style.border = "1px solid red";
                        this.$refs.plate_error_template.style.color = "red";
                        this.formIsValid = false;
                    }else {
                        this.$refs.plate_error_template.style.display = "none";
                        this.$refs.plate_input_div.style.border = "1px solid rgb(75, 44, 114)";
                        this.formIsValid = true;
                    }
                }


            },
            createVehicle  ($event) {
                $event.preventDefault();
                   if(!this.plateNumber) {
                        this.$toast.open({
                            message: this.$t('text.createVehicle.plateNumberMissing'),
                            type: 'error',
                            duration: 5000
                        });
                        return;
                    }
                //    if( !this.name ) {
                //     this.$toast.open({
                //         message: this.$t('text.createVehicle.fullNameMissing'),
                //         type: 'error',
                //         duration: 5000
                //     });
                //     return;
                // }
                //  if(!this.phone ) {
                //     this.$toast.open({
                //         message: this.$t('text.createVehicle.contactPhoneMissing'),
                //         type: 'error',
                //         duration: 5000
                //     });
                //     return;
                // }
                
                 if(!this.vehicleType || this.vehicleType === this.$t('text.createVehicle.selectVehicleType')) {
                    this.$toast.open({
                        message: this.$t('text.createVehicle.vehicleTypeMissing'),
                        type: 'error',
                        duration: 5000
                    });
                    return;
                }
                if(!this.carMakeId || this.carMakeId === this.$t('text.createVehicle.selectVehicleMake')) {
                    this.$toast.open({
                        message: this.$t('text.createVehicle.carMakeMissing'),
                        type: 'error',
                        duration: 5000
                    });
                    return;
                }
                if( !this.carModelId || this.carModelId === this.$t('text.createVehicle.selectVehicleModel')) {
                    this.$toast.open({
                        message: this.$t('text.createVehicle.carModelMissing'),
                        type: 'error',
                        duration: 5000
                    });
                    return;
                }
                if(!this.modelYear) {
                    this.$toast.open({
                        message: this.$t('text.createVehicle.modelYearMissing'),
                        type: 'error',
                        duration: 5000
                    });
                    return;
                }
               
             
                let data = {
                    "plateNumber": this.plateNumber,
                    "carMakeId": this.carMakeId,
                    "carModelId": this.carModelId,
                    // "phoneNo": this.phone,
                    // "driver": this.name,
                    "type": this.vehicleType,
                    "carYear": parseInt(this.modelYear),
                }
                this.isButtonDisabled = true;
                $('.loader').show();
                this.axios.post(`${configObject.apiBaseUrl}/Track/TrackNewVehicle`, data, configObject.authConfig())
                    .then(() => {               
                        this.$toast.open({
                            message: this.$t('text.createVehicle.successfullyCreated'),
                            type: 'success',
                            duration: 3000
                        });
                        this.amount = null,
                        this.returnBalanceTo = null,
                        this.validity = null
                        $('.loader').hide();
                        this.isButtonDisabled = false;
                        this.$router.push({name: 'vehicle'});
                    }).catch(error => {
                        this.$toast.open({
                            message: error.response.data.message ,
                            type: 'error',
                            duration: 5000
                    });       
                    $('.loader').hide();  
                    this.isButtonDisabled = false;
                });
            },
            getCarMakes() {
                this.axios.get(`${configObject.apiBaseUrl}/Track/GetCarMakes`, configObject.authConfig())
                    .then(response => {
                        this.carMakes = response.data;
                    }).catch (error => {
                          if(error.message && error.message === 'Network Error') {
                                this.$toast.open({
                                message: "Network Error, Please Check Your Internet Connection",
                                type: "error",
                                duration: 5000
                                });
                            }else {
                                this.$toast.open({
                                message: "An Error Occured",
                                type: "error",
                                duration: 5000
                                });
                            }
                    })
            },
             getCarModel() {
                this.axios.get(`${configObject.apiBaseUrl}/Track/GetCarModel/?makeId=${this.carMakeId}`, configObject.authConfig())
                    .then(response => {
                        this.carModels = response.data;
                    }).catch (error => {
                    })
            },

        }
    }
</script>
